import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useDeleteVersion = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteVersion, isLoading } = useMutation(
    async ({ id }) => {
      const response = await SrxApi.delete(`/versions/${id}`);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          toast.success(data?.message || "Version deleted successfully!");
          queryClient.invalidateQueries(["getAllVersion"]);
          queryClient.invalidateQueries(["currentVersion"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete version";
        toast.error(errorMessage);
      },
    }
  );

  return { deleteVersion, isDeleteVersionLoading: isLoading };
};

export default useDeleteVersion;

